import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay]);

interface CarouselSwiperProps {
    el: HTMLElement;
}

const Carousel = ({ el }: CarouselSwiperProps): void => {
    const swiperContainer = el.querySelector('.swiper') as HTMLElement;

    if (!swiperContainer) {
        return;
    }

    const prevEl: HTMLElement | null = el.querySelector('.carousel-prev');
    const nextEl: HTMLElement | null = el.querySelector('.carousel-next');

    const paginationEl = swiperContainer.querySelector('.swiper-pagination') as HTMLElement;

    const slidesPerView = parseInt(swiperContainer.dataset.slides || '2');
    const effect = swiperContainer.dataset.effect || 'slide';
    const autoplayEnabled = swiperContainer.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(swiperContainer.dataset.autodelay ?? '5000');
    const loopEnabled = swiperContainer.dataset.loop === 'true';
    const initialSlide = swiperContainer.dataset.loop === 'true' ? 1 : 0;

    const carouselSwiper = new Swiper(swiperContainer, {
        init: false,
        loop: loopEnabled,
        loopAdditionalSlides: 1,
        effect,
        slidesPerView: 1,
        initialSlide,
        spaceBetween: 16,
        watchOverflow: true,
        watchSlidesProgress: true,
        breakpoints: { 1024: { slidesPerView } },
        autoplay: autoplayEnabled ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
        } : false,
        navigation: {
            nextEl,
            prevEl,
        },
        pagination: {
            el: paginationEl,
            clickable: true,
        },
    });

    carouselSwiper.init();
};

export default Carousel;
